module.exports = __webpack_public_path__ + "yahoojp_logo.0fa249b08f662405ca0cf02af6e5abde.png";